import { KeyboardArrowDown } from "@mui/icons-material";
import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface TypeText {
    tertiary: string;
  }
  interface TypographyVariants {
    display: React.CSSProperties;
    body3: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    display?: React.CSSProperties;
    body3?: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    display: true;
    body3: true;
  }
  interface TypographyPropsColorOverrides {
    tertiary: true;
  }
}
export const theme = createTheme({
  shape: {
    borderRadius: 6,
  },
  typography: {
    fontFamily: "Inter, sans-serif",
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    display: {
      fontWeight: 700,
      fontSize: 32,
      lineHeight: "120%",
    },
    h1: {
      fontWeight: 600,
      fontSize: 24,
      lineHeight: "130%",
    },
    h2: {
      fontWeight: 600,
      fontSize: 20,
      lineHeight: "140%",
    },
    h3: {
      fontWeight: 600,
      fontSize: 18,
      lineHeight: "140%",
    },
    subtitle1: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: "160%",
    },
    body1: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "160%",
    },
    body2: {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: "150%",
    },
    body3: {
      fontWeight: 400,
      fontSize: 11,
      lineHeight: "140%",
    },
  },
  palette: {
    primary: {
      main: "#872EE5",
    },
    secondary: {
      main: "#5E13891A",
    },
    text: {
      primary: "#1F2937",
      secondary: "#6B7280",
      tertiary: "#9CA3AF",
    },
    divider: "#E0E3EB",
    background: {
      default: "#F4F5F7",
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          boxSizing: "border-box",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E0E3EB",
            borderRadius: "8px",
          },
          "& .MuiSvgIcon-root": {
            color: "#9CA3AF",
            fontSize: "20px",
          },
        },
        input: {
          height: "46px",
          boxSizing: "border-box",
          fontWeight: 500,
          fontSize: "14px",
          "&::placeholder": {
            fontWeight: 400,
            fontSize: "14px",
            color: "#9CA3AF",
            opacity: 1,
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        outlined: {
          padding: "12px 16px",
          height: "46px",
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
        },
      },
      defaultProps: {
        IconComponent: KeyboardArrowDown,
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          fontSize: "14px",
          height: "36px",
          // padding: "16px 20px",
          fontWeight: 600,
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          fontSize: "14px",
          fontWeight: 500,
        },
        root: {
          "& .MuiInputBase-root": {
            height: "46px",
            "& input": {
              height: "100%",
            },
          },
        },
      },
    },

    MuiSvgIcon: {
      defaultProps: {
        fontSize: "small",
      },
    },

    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: "12px",
        },
      },
    },
  },
});
